export default "__VITE_ASSET__CT9V6VTz__"